












































































import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import Draggable from "vuedraggable";
import _ from "lodash";

@Component({components: {Draggable}})
export default class BucketingGroups extends Vue {

    @Prop({default:200, type: Number})
    columnWidth!: number;

    /**
     * {
     *   id: "list_1",
     *   name: "List",
     *   readonly: false
     * }
     */
    @Prop()
    lists!: any[];

    /**
     * {
     *   id: "Outstanding",
     *   name: "Outstanding",
     *   description: "The most outstanding objects go in here",
     *   bins : [
     *     see below. Optional param to have custom bins per list. NOT IMPLEMENTED YET
     *   ]
     * }
     */
    @Prop()
    bins!: any[];

    /**
     *  {
     *    id: "ITEM_1",
     *    binId: "Outstanding",
     *    groupId: "Sandbox"
     *    name: "",   - For Default View
     *    description: "",   - For Default View
     *  }
     */
    @Prop()
    items!: any[];

    @Prop({default: false})
    dense!: boolean;

    @Prop({default: false})
    flat!: boolean;

    @Prop({default: false})
    disableDrag!: boolean;

    private groupedData: any = {};

    @Watch('items')
    updateData() {
        let groupedData: any = _.groupBy(this.items, f => f.listId);
        for (let list in this.lists) {
            if (!groupedData[this.lists[list].id]) {
                groupedData[this.lists[list].id] = [];
            }
        }
        for (let key in groupedData) {
            groupedData[key] = _.groupBy(groupedData[key], f => f.binId);
            for (let binIndex in this.bins) {
                if (!groupedData[key][this.bins[binIndex].id]) {
                    groupedData[key][this.bins[binIndex].id] = [];
                }
            }
        }
        this.groupedData = groupedData;
        // this.drawLines();
    }

    mounted() {
        this.updateData();
    }

    private disableDraggable(list) {
        if (!this.disableDrag) {
            return list.readonly
        } else {
            return true;
        }
    }

    private emitChange(event: any, listId: string, binId: string) {
        // this.drawLines();
        if (event.added) {
            event.added.element.listId = listId;
            event.added.element.binId = binId;
        }

        let emitEvent = Object.assign({
            listId: listId,
            binId: binId,
            binSize: this.groupedData[listId][binId].length
        }, event);

        this.$emit('change', emitEvent);
        if (emitEvent.added) {
            this.$emit('added', emitEvent);
        } else if (emitEvent.removed) {
            this.$emit('removed', emitEvent);
        } else if (emitEvent.moved) {
            this.$emit('moved', emitEvent);
        }
    }


}
